module.exports = __webpack_public_path__ + "img/1.03974a2a.png";